"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shallowClone = void 0;
function shallowClone(value) {
    if (typeof value !== "object" || !value || value instanceof Date || value instanceof RegExp)
        return value;
    return (Array.isArray(value)) ? [...value] : Object.assign({}, value);
}
exports.shallowClone = shallowClone;
//# sourceMappingURL=clone.js.map